export enum EventBlueprintStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  FINISHED = 'finished',
}

export enum EventStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled',
  FINISHED = 'finished',
}
